import { render } from "./AbtestPage.vue?vue&type=template&id=04c9b506"
import script from "./AbtestPage.vue?vue&type=script&lang=js"
export * from "./AbtestPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__